/**
 * Utility functions for Explore page
 */

/**
 * Extracts the primary media URL, media type (image/video), and count from a post.
 * Handles string, array of strings, array of objects, and single object mediaUrl structures.
 */
export const extractPostMedia = (post) => {
	if (!post) {
		return { url: "", isVideo: false, hasMultiple: false, count: 0, mediaType: "image" };
	}

	const rawMedia = post.mediaUrl;
	let count = 0;
	let firstItem = null;

	if (Array.isArray(rawMedia)) {
		count = rawMedia.length;
		firstItem = rawMedia[0];
	} else if (rawMedia) {
		count = 1;
		firstItem = rawMedia;
	}

	let url = "";
	if (typeof firstItem === "string") {
		url = firstItem;
	} else if (firstItem && typeof firstItem === "object") {
		url = firstItem.url || firstItem.mediaUrl || "";
	}

	// Check if video by mediaType or URL extension
	const videoRegex = /\.(mp4|mov|wmv|avi|flv|mkv|webm)(\?.*)?$/i;
	const isVideo =
		post.mediaType === "video" ||
		(typeof url === "string" && videoRegex.test(url));

	return {
		url: url || "",
		isVideo: Boolean(isVideo),
		hasMultiple: count > 1,
		count,
		mediaType: isVideo ? "video" : (post.mediaType || "image"),
	};
};

/**
 * Formats like and comment counts cleanly (e.g., 1200 -> 1.2k)
 */
export const formatCount = (count) => {
	const num = Number(count) || 0;
	if (num >= 1000000) {
		return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
	}
	if (num >= 1000) {
		return (num / 1000).toFixed(1).replace(/\.0$/, "") + "k";
	}
	return num.toString();
};
